module.exports = __webpack_public_path__ + "static/media/bijyutsu_paint_man2.040caab1.png";